<template>
  <div :class="classTransform" v-bind="$attrs" :style="stylesTransformMoving">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AnimationTransform',
  props: {
    name: {
      type: String,
      default: null,
    },
    start: {
      type: Boolean,
      default: false,
    },
    toY: {
      type: Number,
      required: true,
    },
    toX: {
      type: Number,
      required: true,
    },
    fromY: {
      type: Number,
      default: 0,
    },
    fromX: {
      type: Number,
      default: 0,
    },
    duration: {
      type: [Number, String],
      default: 0.5,
    },
    delay: {
      type: [Number, String],
      default: 300,
    },
    timing: {
      type: String,
      default: 'linear',
    },
    pressed: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Object,
    },
  },
  computed: {
    classTransform() {
      let clazz = { 'transform-moving': true };

      if (this.pressed) {
        clazz['transform-moving__focus'] = true;
      }

      if (this.item.image) {
        clazz = Object.assign(
          {},
          { ...clazz },
          {
            [this.item.image]: true,
          },
        );

        if (this.item.imageHover && this.item.imageHover !== this.item.image) {
          clazz = Object.assign(
            {},
            { ...clazz },
            {
              [this.item.imageHover]: this.hover,
            },
          );
        }
      }

      return {
        ...clazz,
      };
    },
    stylesTransformMoving() {
      let stylesTransform = {};

      if (this.playStart) {
        stylesTransform['transitionDuration'] = `${this.duration}s`;
        stylesTransform['transitionProperty'] = 'transform';
        stylesTransform['transitionTimingFunction'] = this.timing;
        stylesTransform[
          'transform'
        ] = `translate(${this.fromX}px, ${this.fromY}px)`;
      } else {
        stylesTransform[
          'transform'
        ] = `translate(${this.toX}px, ${this.toY}px)`;
      }

      return {
        ...stylesTransform,
      };
    },
  },
  data() {
    return {
      playStart: false,
      hover: false,
      item: {},
    };
  },
  mounted() {
    if (this.pressed) {
      this.$el.setAttribute('tabindex', '0');
      this.$el.setAttribute('role', 'button');
      this.$el.addEventListener('click', this.handleClick);
      this.$el.addEventListener('keydown', this.handleKeydown);
    }

    this.$el.addEventListener('transitionstart', this.handleTransitionStart);
    this.$el.addEventListener('transitionend', this.handleTransitionEnd);

    this.$el.addEventListener('mouseover', this.handleMouseTabEnter);
    this.$el.addEventListener('mouseleave', this.handleMouseTabLeave);
    this.$el.addEventListener('focus', this.handleMouseTabEnter);
    this.$el.addEventListener('blur', this.handleMouseTabLeave);
  },
  methods: {
    handleTransitionStart() {
      this.$emit('onTransitionStart', this.name);
    },
    handleTransitionEnd() {
      this.$emit('onTransitionEnd', this.name);
    },
    handleClick() {
      this.$emit('onPressed', this.name);
    },
    handleKeydown(e) {
      if (e.keyCode === 32) {
        e.preventDefault();
        this.handleClick();
      }
    },
    handleMouseTabEnter() {
      this.hover = true;
    },
    handleMouseTabLeave() {
      this.hover = false;
    },
  },
  watch: {
    start: {
      immediate: true,
      handler: function (value) {
        if (value) {
          setTimeout(() => {
            this.playStart = value;
          }, parseInt(this.delay));
        } else {
          this.playStart = false;
        }
      },
    },
    image: {
      immediate: true,
      handler: function (value) {
        this.item = Object.assign({}, { ...value });
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
.transform-moving
  &__focus
    cursor pointer
</style>
